export const visit = "Visit"
export const cleaning = "Cleaning"
export const ForgotPassword = "Forgot Password?"
export const OTP = "Please check your register email and enter 6 digit passcode to retrive password."
export const EnterOTP  = "Enter Passcode"
export const EnterNewPassword = "Enter New Password"
export const RetypePassword  = "Retype Password"
export const Submit  = "Submit"
export const Cancel  = "Cancel"
export const emptyEmail = "Email address cannot be empty"
export const emptyOTP = "Please Enter Passcode"
export const emptyPassword = "Please Enter Password"
export const emptyRePassword  = "Please Enter Password again"
export const emptyPasswordMismatch = "Passwords do not match"
export const emptyPasswordPolicy = "Please follow the Password Policy"
export const emptyInvalidPasscode = "Invalid Passcode"
export const PasswordPolicy1 = "Password hints : 8 characters or longer."
export const PasswordPolicy2 = "At least one number or symbol (likeA-Z,a-z,0-9,!$*@?\"#)"
export const RegisterEmail = "Please enter your register email to reset password."
export const enterRegisterEmail = "Enter register email"
export const InvalidEmail = "Invalid email address. Email address should be same as login email."
export const Success  = "Success"
export const Email = "Email sent successfully."
export const Passcode  = "Please enter 6 digit passcode to reset password."
export const PwdChanged = "You have successfully changed password."
export const TokenExpire = "Token Expired."
export const errNewPwd = "New password should not be same as old password."